import type { z } from 'zod';

import { inventoryKitItemQuerySchema } from './inventory-kit-item-query-schema';

export const inventoryKitItemFormSchema = inventoryKitItemQuerySchema.refine((data) => !!data.inventory, {
  path: ['inventory'],
  message: 'Inventory is required',
});

export type InventoryKitItemFormSchema = z.infer<typeof inventoryKitItemFormSchema>;
